import { styled, Dialog, dialogClasses, dialogContentClasses, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, DialogActions as DialogActions$1 } from "@mui/material";
const Root = styled(Dialog)(({ theme }) => ({
  [`& .${dialogClasses.paper}`]: {
    margin: theme.spacing(2),
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    maxWidth: 600,
    width: "100%"
  },
  [`& .${dialogContentClasses.root}`]: {
    position: "relative"
  }
}));
const DialogTitle = styled(DialogTitle$1)(({ theme }) => ({
  padding: theme.spacing(3, 3, 2, 3),
  color: theme.palette.grey[800]
}));
const DialogContent = styled(DialogContent$1)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  color: theme.palette.grey[700]
}));
const DialogActions = styled(DialogActions$1)(({ theme }) => ({
  padding: theme.spacing(3, 2, 3, 3)
}));
export {
  DialogActions,
  DialogContent,
  DialogTitle,
  Root
};
